<ion-item-divider [style]="'color: ' + textColor + '; --background: ' + color + ';'" [sticky]="sticky">
  <ion-label [style]="'font-size: ' + fontSize + '; font-weight: ' + fontWeight + '; text-align: center; margin: 10px auto;'">{{ title }}</ion-label>
</ion-item-divider>
